import { glsGetOidFromToken } from '@gls-its-frontends/common/gls-helpers';
import { defineStore } from 'pinia';
import { computed, ComputedRef, ref, Ref } from 'vue';
import Privilege from '@/enums/privilege';

const mainStore = defineStore('mainStore', () => {
    const accessToken: Ref<string | null> = ref(null);
    const privileges: Ref<Privilege[] | null> = ref(null);
    const username: Ref<string | null> = ref(null);
    const oid: ComputedRef<string | null> = computed((): string | null => glsGetOidFromToken(accessToken.value));
    const hasWritePrivilege: ComputedRef<boolean> = computed((): boolean => !!privileges.value?.includes(Privilege.WRITE));

    const setAccessToken = (token: string): void => {
        accessToken.value = token;
    };

    const setPrivileges = (newPrivileges: Privilege[] | null): void => {
        privileges.value = newPrivileges;
    };

    const setUsername = (name: string): void => {
        username.value = name;
    };

    return {
        username,
        accessToken,
        privileges,
        oid,
        hasWritePrivilege,
        setAccessToken,
        setPrivileges,
        setUsername
    };
});

export default mainStore;
